<template>
  <span class="str-split" :class="{ 'sub-text-wrap': subText }">
    <template v-if="!inputElement">
      <template v-for="(str, index) in splitStringValue">
        <span v-if="index < 6" :style="splitWidth" :key="index">
          {{ str }}
        </span>
        <span v-if="index >= 6" :style="splitWidth" :key="index"></span>
      </template>
    </template>

    <template v-else>
      <input
        v-if="(maxLength !== null) | (maxLength !== undefined)"
        type="text"
        :value="value"
        @input="handleCheckInput"
        @blur="handleUpdateInput"
        :maxLength="maxLength ? maxLength : ''"
        :class="{ err: err }"
        :style="styleMode"
      />

      <template v-for="(str, index) in splitStringValue">
        <span :style="splitWidth" :key="index">
          {{ str }}
        </span>
      </template>
    </template>

    <span id="sub-text" v-if="subTextlength !== 0" :style="subTextStyle">{{
      subText
    }}</span>
  </span>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
      required: false,
    },
    setKey: {
      type: String,
      default: '',
      required: false,
    },
    splitlength: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    inputElement: {
      type: Boolean,
      required: false,
      default: false,
    },
    subTextlength: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    subText: {
      type: String,
      default: '',
      required: false,
    },
    maxLength: {
      type: String,
      required: false,
      default: null,
    },
    err: {
      type: Boolean,
      required: false,
      default: false,
    },
    validModeAlphaNumeric: {
      type: Boolean,
      required: false,
      default: false,
    },
    styleMode: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    splitWidth() {
      return {
        '--split-width': Number(this.splitlength),
      }
    },
    subTextStyle() {
      return {
        '--sub-text-width': Number(this.subTextlength),
        '--split-width': Number(this.splitlength),
      }
    },
    splitStringValue() {
      let splitStringValue = []

      let loopCnt = this.splitlength - 4

      if (this.value || this.value === 0) {
        splitStringValue = String(this.value)
          .split('')
          .filter(data => data && data !== '.')

        loopCnt = loopCnt - splitStringValue.length
      }

      for (let index = 0; index < loopCnt; index++) {
        splitStringValue.unshift('')
      }

      for (
        let index = splitStringValue.length;
        index < this.splitlength;
        index++
      ) {
        splitStringValue.push('')
      }

      if (this.subTextlength !== 0) {
        splitStringValue.splice(0, this.subTextlength)
      }

      return splitStringValue
    },
  },
  methods: {
    handleUpdateInput(e) {
      if (e.target.value === '-') e.target.value = ''

      if (e.target.value === '') {
        this.$emit('input-emit', {
          setKey: this.setKey,
          value: '',
        })
      } else if (this.validModeAlphaNumeric) {
        this.$emit('input-emit', {
          setKey: this.setKey,
          value: e.target.value,
        })
      } else {
        this.$emit('input-emit', {
          setKey: this.setKey,
          value: Number(e.target.value),
        })
      }
    },
    handleCheckInput(e) {
      if (this.validModeAlphaNumeric) {
        e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '')
      } else {
        e.target.value = e.target.value.replace(/[^-?0-9+$]/g, '')
      }

      if (this.maxLength && e.target.value.length > this.maxLength) {
        e.target.value = e.target.value.slice(0, -1)
      }

      return e.target.value
    },
  },
}
</script>

<style lang="scss" scoped>
.str-split {
  position: relative;
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  margin: -5px;
  display: flex;
  justify-content: space-between;

  #sub-text {
    font-size: 10px;
    padding: 0 2.5px;
    width: calc((100% / var(--split-width)) * var(--sub-text-width));
    justify-content: flex-start;
    text-align: left;
  }

  > span {
    flex: none;
    width: calc(100% / var(--split-width));
    border-right: 1px #808080 solid;
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0;
    justify-content: center;
    text-align: center;
    &:last-of-type {
      border-right: none;
    }
  }

  > span:nth-child(n + 7) {
    border: none;
  }

  > input {
    width: 100%;
    margin: 2.5px;
    padding: 5px;
    text-align: right;
  }

  > input.err {
    background-color: rgba(234, 85, 80, 0.5);
    border-radius: 2.5px;
    border: 1px solid #808080;
  }

  > input + span,
  > input + span ~ span {
    display: none;
  }
}

@media print {
  .str-split {
    input {
      display: none;
    }

    > input + span,
    > input + span ~ span {
      flex: none;
      width: calc(100% / var(--split-width));
      border-right: 1px #808080 solid;
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0;
      justify-content: center;
      text-align: center;
      &:last-of-type {
        border-right: none;
      }
    }
  }
}
</style>
